import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Dialog as HeadlessDialog } from '@flywire/react-headlessui';
import { cx } from '../../utils';
export const useDescriptionClasses = ({ className }) => {
    return cx('font-normal', className);
};
const DescriptionComponent = forwardRef(({ className, ...rest }, ref) => {
    const classes = useDescriptionClasses({ className });
    return _jsx(HeadlessDialog.Description, { className: classes, ref: ref, ...rest });
});
DescriptionComponent.displayName = 'Description';
const Description = DescriptionComponent;
export { Description };
//# sourceMappingURL=Description.js.map